export default __webpack_public_path__ + "static/media/home-icon.363da510.svg";